export const GET_STORE_CATEGORIES_START =
  'GET_STORE_CATEGORIES_START';
export const GET_STORE_CATEGORIES_SUCCESS =
  'GET_STORE_CATEGORIES_SUCCESS';
export const GET_STORE_CATEGORIES_ERROR =
  'GET_STORE_CATEGORIES_ERROR';
export const GET_STORE_CATEGORIES_END = 'GET_STORE_CATEGORIES_END';
